// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title-info-added-mass {\n  margin: 0;\n  padding: 10px;\n  font-size: 80%;\n}\n", "",{"version":3,"sources":["webpack://./pages/case-0402-01/AddedMass.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,cAAc;AAChB","sourcesContent":[".title-info-added-mass {\n  margin: 0;\n  padding: 10px;\n  font-size: 80%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
